import LedgerWorksPng from "@images/ledger-works-logo.png";

const LedgerWorksLogo = () => {
  return <img src={LedgerWorksPng} alt="Ledger Works logo" />;
};

export default LedgerWorksLogo;
